import React from 'react';

export default class MapMarker extends React.Component {
  constructor(props) {
    super(props);

    this.containerRef = React.createRef();
  }

  componentWillUnmount = () => {
    document.removeEventListener('click', this.outsideClick, false);
  };

  componentDidUpdate = prevProps => {
    const { closeTooltip, active } = this.props;

    if (closeTooltip) {
      if (!prevProps.active && active) {
        document.addEventListener('click', this.outsideClick, false);
      } else if (prevProps.active && !active) {
        document.removeEventListener('click', this.outsideClick, false);
      }
    }
  };

  outsideClick = e => {
    if (this.containerRef.current.contains(e.target)) {
      return;
    }

    const { closeTooltip } = this.props;
    closeTooltip();
  };

  render() {
    const { active, title, tooltip } = this.props;

    return (
      <div
        ref={this.containerRef}
        className="overlayer"
        style={{ zIndex: active ? '21' : '20', transform: 'translate(-50%, -100%)' }}
      >
        {active && tooltip ? (
          <div className="popover top block relative m-b-15" style={{ width: '240px' }}>
            <div className="arrow" />
            <h3 className="popover-title">{title}</h3>
            <div className="popover-content">{tooltip}</div>
          </div>
        ) : null}

        <div className="text-center">
          <i className="fa fa-map-marker-alt map-pin" style={{ fontSize: '30px' }} />
        </div>
      </div>
    );
  }
}
MapMarker.defaultProps = {
  active: true,
  title: '',
  tooltip: null,
};
